export default function isGraphqlError(error) {
  return Boolean(error && error.graphqlError);
}
